<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap mb-2>
      <v-flex md4 xs12>
        <summary-b></summary-b>
      </v-flex>
      <v-flex md4 xs12>
        <daily size="m"></daily>
      </v-flex>
      <v-flex md4 xs12>
        <fees></fees>
      </v-flex>
    </v-layout>

    <draggable
      tag="v-layout"
      v-model="draggableModules"
      v-bind="dragOptions"
      :component-data="{attrs: {wrap: true}}"
    >
      <v-flex md6 sm12 v-for="e in draggableModules" :key="e.id" class="modules-list-item">
        <component v-bind:is="e.content"></component>
      </v-flex>
    </draggable>
  </v-container>
</template>

<script>
import store from '@/store'
import draggable from 'vuedraggable'
/* modules */
import summaryB from '@/components/modules/Summary'
import Daily from '@/components/modules/Daily'
import Fees from '@/components/modules/Fees'
import visDep from '@/components/modules/Visinform-departure'
import visArr from '@/components/modules/Visinform-arrival'
import worldmap from '@/components/modules/Worldmap'
import perron from '@/components/modules/Perron'
/* data */
import Dt from '@/table-data.js'
export default {
  components: {
    draggable,
    visDep,
    visArr,
    worldmap,
    summaryB,
    Fees,
    Daily,
    perron
  },
  data() {
    return {
      dt: Dt,
      search: '',
      chartTabs: 'tab-1',
    }
  },
  mounted: function() {
    store.commit('setPageTitle', 'Главная')
  },
  computed: {
    dragOptions: {
      get() {
        return store.getters.getDragOptions
      },
    },
    draggableModules: {
      get() {
        return store.getters.getDraggableModules(true)
      },
      set(list) {
        store.commit('draggablePosition', list)
      },
    },
  },
}
</script>
